import { render } from "./Folder.vue?vue&type=template&id=5be8adaf"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"

import "./Folder.vue?vue&type=style&index=0&id=5be8adaf&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__